import { Box, Typography } from "@mui/material";
import MultiSelectDropdown from "components/MultiSelectDropdown/MultiSelectDropdown";
import { PLATFORM_OPTIONS, DEVICE_OPTIONS } from "./utils";
import { useState } from "react";
import { validatePlacementDevice, validatePlacementPlatform } from "features/meta-travel-ads-campaign/Utils/validators/campaignSettingsValidators";

const PlacementDetails = ({ placementDetails, setPlacementDetails, errors }) => {  
  const [placementPlatformStatus, setPlacementPlatformStatus] = useState(null);
  const [placementDeviceStatus, setPlacementDeviceStatus] = useState(null);

  const handlePlacementPlatformBlur = async (platforms) => {
    const result = await validatePlacementPlatform(platforms);
    if(result.success) {
      delete errors.placementPlatform;
    }
    setPlacementPlatformStatus(
      result.success
        ? { success: true, error: null }
        : { success: false, error: result.error || "Invalid placement platform" }
    );
  }

  const handlePlacementDeviceBlur = async (devices) => {
    const result = await validatePlacementDevice(devices);
    if(result.success) {
      delete errors.placementDevice;
    }
    setPlacementDeviceStatus(
      result.success
        ? { success: true, error: null }
        : { success: false, error: result.error || "Invalid placement device" }
    );
  }
  return (
    <Box className="placementDetails">
      <Box display="flex" alignItems="center">
        <Typography className="sectionTitle">Placement</Typography>
      </Box>
      <Box className="sectionContent">
        <MultiSelectDropdown
          placeholder="Facebook, Instagram and Audience Network"
          helperText={"Platforms"}
          items={PLATFORM_OPTIONS}
          onChange={(selected) => setPlacementDetails({...placementDetails, placement_platform: selected.filter(item => item.isSelected).map(item => String(item.id))})}
          selectedItems={PLATFORM_OPTIONS.filter(item => placementDetails?.placement_platform?.includes(String(item.id))).map(item => item.name)}
          error={errors.placementPlatform}
          onBlur={() => handlePlacementPlatformBlur(placementDetails.placement_platform)}
        />
        <MultiSelectDropdown
          placeholder="All Devices and operating systems"
          helperText={"Device Settings"}
          items={DEVICE_OPTIONS}
          onChange={(selected) => setPlacementDetails({...placementDetails, placement_device: selected.filter(item => item.isSelected).map(item => String(item.id))})}
          selectedItems={DEVICE_OPTIONS.filter(item => placementDetails?.placement_device?.includes(String(item.id))).map(item => item.name)}
          error={errors.placementDevice}
          onBlur={() => handlePlacementDeviceBlur(placementDetails.placement_device)}
        />
      </Box>
    </Box>
  );
};

export default PlacementDetails;